import React from "react";
import { connect } from "react-redux";
import FinxPay from "../../assests/images/finxpay.png";
import FinxPayLogo from "../../assests/images/logo.png";
import "./Header.css";
import Avatar from "react-avatar";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";

import {
  isSuperAdmin,
  isUserAdmin,
  removeUserSession,
} from "../../utils/comman/Common";
import { GET_PROFILE } from "../../redux/Profilelogin/types";
import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import axiosinstances from "../../Helper/useAxios";
import { selectedRetailer } from "../../redux/SelectedRetailer/action";

const Header = () => {
  const requesterId = useSelector(
    (state) => state.selectedretailerReqesterReducer.requesterId
  );
  const [axiosInstance] = axiosinstances();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const retailerName = sessionStorage.getItem("rname");
  const [searched, setSearched] = useState({
    name: retailerName ? retailerName : "",
    typing: false,
    typingTimeout: 0,
  });
  const [retailerList, setRetailerList] = useState([]);

  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const profiledata = useSelector(
    (state) => state.getprofilereducer?.getprofile?.businessInfo
  );
  const profiledataid = useSelector(
    (state) => state.getprofilereducer?.getprofile
  );
  const selectedId = useSelector((state) => state.selectedRetailerReducer);
  //console.log('selectedId', selectedId)
  //console.log('isSuperAdmin', isSuperAdmin(id))
  const e = JSON.parse(sessionStorage.getItem("token"));
  const name = profiledata?.name;
  const userid = profiledataid?.id;
  //console.log('userid', userid)
  //console.log('ID', id)
  useEffect(() => {
    dispatch({ type: GET_PROFILE, data: userid });
  }, []);
  const showAvtar = () => {
    return <Avatar name={name} size={36} round="18px" />;
  };
  const myAvtar = React.useMemo(() => showAvtar(), [name]);

  const fetchListOfRetailer = async (searchText) => {
    let url = `/api/v1/retailer/search/${searchText}`;
    if (requesterId !== undefined && requesterId !== null) {
      url = `/api/v1/retailer/search/${searchText}/${requesterId}`;
    }
    const response = await axiosInstance
      .get(url, {
        headers: {
          Authorization: `Bearer ${e}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      })
      .then((res) => {
        //console.log('res....>', res)
        //  return res
        setRetailerList(res.data.retailers);
      })
      .catch((err) => {
        //console.log(err);
        toast.error("Something went wrong");
      });
    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };
  const profile = () => {
    navigate("/profile");
  };
  const logOut = () => {
    alert("Are you Sure For Logout");
    removeUserSession();
    navigate("/", { replace: true });
    window.location.reload();
  };

  const client = () => {
    navigate("/clients");
  };
  const clearSearch = () => {
    dispatch(selectedRetailer({ id: null, name: "" }));
    sessionStorage.removeItem("rname");
    sessionStorage.removeItem("rid");
    setRetailerList([]);
  };
  const taLoadRequest = (event) => {
    event.preventDefault();
    navigate("/ta-load-request");
  };
  //dmtSuppConfig
  const navToProductList = (event, check) => {
    event.preventDefault();
    if (check === "proList") {
      navigate("/product-list");
    } else if (check === "progroupList") {
      navigate("/product-group-list");
    } else if (check === "createNewGroup") {
      navigate("/create-new-product-group");
    } else if (check === "escrow") {
      navigate("/escrow");
    }
  };

  const searchedHadler = (event) => {
    if (searched.typingTimeout) {
      clearTimeout(searched.typingTimeout);
    }
    if (!searched.typing) {
      setRetailerList([]);
    }
    dispatch(selectedRetailer({ id: null, name: event.target.value }));
    setSearched({
      name: event.target.value,
      typing: true,
      typingTimeout: setTimeout(function () {
        // sendToParent(searched.name);
        if (event.target.value !== "") {
          fetchListOfRetailer(event.target.value);
        } else {
          setRetailerList([]);
          sessionStorage.removeItem("rname");
          sessionStorage.removeItem("rid");
          dispatch(selectedRetailer(null));
        }
      }, 1200),
    });
  };

  const selectedRetailerHandler = (val) => {
    setSearched((prev) => ({
      ...prev,
      name: val.businessInfo.name,
      typing: false,
    }));
    dispatch(selectedRetailer({ id: val?.id, name: val?.businessInfo?.name }));
    sessionStorage.setItem("rname", val.businessInfo.name);
    sessionStorage.setItem("rid", val.id);
  };

  return (
    <div className="header">
      <div className="container-fluid">
        <div className="row">
          <div className="col-2 col-md-4">
            <div className="logo">
              <a href="/bill-payment">
                <img
                  src={FinxPay}
                  alt="FinXpay"
                  className="d-none d-md-block"
                />
                <img
                  src={FinxPayLogo}
                  alt="FinXpay"
                  className="d-block d-md-none"
                />
              </a>
              {isSuperAdmin(id) || isUserAdmin(id) ? (
                <h3>Admin</h3>
              ) : (
                <h3>{"Retailer "}</h3>
              )}
            </div>
          </div>
          {(isSuperAdmin(id) || isUserAdmin(id)) && (
            <div class="col-12 col-sm-4 col-md-3 col-lg-4 col-xl-3  d-sm-block align-self-center">
              <div class="search allsearch">
                <form autocomplete="off" action="#">
                  <div class="autocomplete">
                    <input
                      id="myInput"
                      type="text"
                      name=""
                      placeholder="Search Retailer..."
                      value={selectedId.name}
                      onChange={searchedHadler}
                    />
                    <button
                      type="button"
                      className="search-btn"
                      onClick={clearSearch}
                    ></button>
                    {/* <input type="button" value="search"/> */}
                    {Array.isArray(retailerList) &&
                      retailerList.length > 0 &&
                      searched.typing && (
                        <div
                          id="myInputautocomplete-list"
                          class="autocomplete-items"
                        >
                          {Array.isArray(retailerList) &&
                            retailerList.length > 0 &&
                            retailerList.map((val, index) => {
                              return (
                                <div
                                  key={index}
                                  onClick={() => selectedRetailerHandler(val)}
                                >
                                  {val.businessInfo.name}
                                  <input type="hidden" value="Denmark" />
                                </div>
                              );
                            })}
                        </div>
                      )}
                  </div>
                </form>
              </div>
            </div>
          )}
          <div
            className={`col-10 ${
              isUserAdmin(id) || isSuperAdmin(id) ? "col-md-5" : "col-md-8"
            }`}
          >
            <div className="profile">
              <div class="dropdown">
                <button
                  class="dropdown-toggle"
                  type="button"
                  id="prolist"
                  data-toggle="dropdown"
                  aria-expanded="false"
                >
                  {myAvtar}
                </button>
                <ul
                  class="dropdown-menu profiledropdown"
                  aria-labelledby="prolist"
                >
                  <li>
                    <button type="button" class="ta" onClick={taLoadRequest}>
                      TA Load Request
                    </button>
                  </li>
                  {isSuperAdmin(id) && isUserAdmin(id) && (
                    <li>
                      <button
                        type="button"
                        class="ta"
                        onClick={(e) => navToProductList(e, "proList")}
                      >
                        Product List
                      </button>
                    </li>
                  )}
                  {isSuperAdmin(id) && isUserAdmin(id) && (
                    <li>
                      <button
                        type="button"
                        class="ta"
                        onClick={(e) => navToProductList(e, "progroupList")}
                      >
                        Product Group List
                      </button>
                    </li>
                  )}
                  {isSuperAdmin(id) && isUserAdmin(id) && (
                    <li>
                      <button
                        type="button"
                        class="ta"
                        onClick={(e) => navToProductList(e, "createNewGroup")}
                      >
                        Create Product Group
                      </button>
                    </li>
                  )}
                  {isSuperAdmin(id) && isUserAdmin(id) && (
                    <li>
                      <button
                        type="button"
                        class="ta"
                        onClick={(e) => navToProductList(e, "escrow")}
                      >
                        Escrow
                      </button>
                    </li>
                  )}
                  <li class="last">
                    <button type="button" class="logout" onClick={logOut}>
                      Logout
                    </button>
                  </li>
                </ul>
              </div>

              <p>
                Hi, <span>{name}</span> - {userid}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
